/**
 * Where a game's Discord team channels and roles come from, reading the old
 * settings of games saved before the admin could choose.
 */
import { GameType } from '../constants/gameTypes';
/**
 * Where the game's team (or Hiders/Seekers) voice channels come from. Unset,
 * Hide and Seek follows its old auto-create toggle (off: the channels the admin
 * picked) and the team games create them, as they always have.
 */
export function getDiscordChannelSource(gameType, settings) {
    if (settings?.channelSource)
        return settings.channelSource;
    if (gameType === GameType.HIDE_AND_SEEK)
        return settings?.autoCreateChannels ? 'create' : 'existing';
    return 'create';
}
/** Where a team game's team roles come from. Unset, the bot creates them, as it always has. */
export function getDiscordRoleSource(settings) {
    return settings?.roleSource ?? 'create';
}
